var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col text-center"},[_c('h1',{staticClass:"text-2xl font-bold"},[_vm._v(_vm._s(_vm.$t('models.resources')))]),_c('p',[_vm._v(_vm._s(_vm.$t('info.resources_info')))]),_c('div',{staticClass:"mt-4"},[_c('vimeo-player',{ref:"player",staticClass:"video-responsive",attrs:{"id":545650230}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }